function buildOrderLookupParams({ shop, token, orderName, emailAddress, phoneNumber }) {
  const params = { shop, token, orderName };

  if (emailAddress) {
    params.emailAddress = emailAddress;
  } else {
    params.phoneNumber = phoneNumber;
  }

  return params;
}

module.exports = { buildOrderLookupParams };
